import React, { useState, useEffect } from "react";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { Link } from "react-router-dom";
import { FaPlus } from "react-icons/fa6";
import cash_delivery from "../assets/images/cash-delivery.png";
import SuccessPopup from "../components/SuccessPopup";
import { useLocation, useNavigate } from "react-router-dom";
import ApiService from "../services/ApiService";
import PageLoader from "../components/PageLoader";
import { toast } from "react-toastify";
import Header from "../components/Header";
import PaymentSection from "../components/PaymentSection";
import Swal from 'sweetalert2';


const Checkout = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('COD');
    const [cardId, setCardId] = useState('');
    const [orderId, setOrderId] = useState('');
    const [activeTab, setActiveTab] = useState(localStorage.getItem('type') || 'delivery');
    const address = JSON.parse(localStorage.getItem("address"));
    const branch = JSON.parse(localStorage.getItem("branch"));
    const promo_code = localStorage.getItem("promo_code");
    const searchParams = new URLSearchParams(window.location.search);
    const offer = searchParams.get('offer') || '';
    const apply_loyalty = localStorage.getItem("apply_loyalty");

    const [cart, setCart] = useState([]);
    const [cards, setCards] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const [isPlacingOrder, setIsPlacingOrder] = useState(false);

    const navigate = useNavigate();
    const { pathname } = useLocation();
    
    useEffect(() => {
      window.scrollTo(0, 0);
      
      // Log localStorage values for debugging
      const selectedCardId = localStorage.getItem('selected_card_id');
      const saveForFuture = localStorage.getItem('save_for_future');
      
      getCart();
      getCards();
      setPaymentMethod((activeTab=='pickup')?'COP':'COD');
      
      // Check if card was added in AddCard
      if (selectedCardId) {
        // toast.info("Card ready for payment! You can now place your order.");
        setPaymentMethod('Card');
        setCardId(selectedCardId);
        getCards();
      }
    }, [pathname]);

  const getCart = async () => {
    try {
      const saveForFuture = localStorage.getItem('save_for_future') || 'false';
      console.log("saveForFuture in cart:", saveForFuture);
      setIsLoader(true);
      let apiData= {type: activeTab, user_address_id: address?._id,branch_id: branch?._id};

      if(promo_code){
        apiData.promo_code = promo_code;
      } else if(offer){
        apiData.promo_code = offer;
      }
      if(String(apply_loyalty)=="true"){
        apiData.apply_loyalty = apply_loyalty;
      }

      const response = await ApiService.request({
        method: "GET",
        url: "/getCart",
        data: apiData
      });
      const data = response.data;

      if (data.status) {
        const items=data.data.cartItems || [];
        if(items.length < 1){
          toast.info("Your cart is empty! Please add items to your cart.");
          navigate('/items');
          return;
        }

        setCart(data.data);
        
        // Store cart total in localStorage for AddCard component
        localStorage.setItem('cart_total', data.data.grand_total || '0');
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoader(false);
    }
  };

  const placeOrder = async () => {
    try {
      setIsLoader(true);
      setIsPlacingOrder(true);
      
      // Process payment if user selected card payment
      let transaction_id=null;
      // if (paymentMethod=='Card' && cardId) {
      //   const response= await makePayment();
      //   if (!response.status) {
      //     toast.error(response.message);
      //     setIsPlacingOrder(false);
      //     return false;
      //   }
      //   transaction_id = response.data?.payment?.id;
      // }
      
      const formData={
          order_from: 'Web',
          delivery_instruction: localStorage.getItem('delivery_instruction'),
          payment_method: paymentMethod,
          transaction_id: transaction_id,
      };
      if (activeTab === 'delivery') {
        formData.user_address_id = address._id;
      }else{
        formData.branch_id = branch._id;
      }
      if(promo_code){
        formData.promo_code = promo_code;
      } else if(offer){
        formData.promo_code = offer;
      }
      if(String(apply_loyalty)=="true"){
        formData.loyalty_points = cart.loyalty_points;
      }
      const response = await ApiService.request({
        method: "POST",
        url: "/placeOrder",
        data:  formData,
      });
      const data = response.data;

      if (data.status) {
        // Check if we need to remove the card after order
        const saveForFuture = localStorage.getItem('save_for_future') || 'false';
        const selectedCardId = localStorage.getItem('selected_card_id');
        console.log("Card deletion check - Save for future:", saveForFuture, "Card ID:", selectedCardId);
        
        if (saveForFuture === 'false' && selectedCardId && paymentMethod === 'Card') {
          // Remove the card since it wasn't saved for future use
          try {
            await removeCard(selectedCardId, false);
            console.log("Card removed successfully after one-time use");
          } catch (error) {
            console.error("Error removing card:", error);
          }
        }
        //Charge and Update Order Payment Status
        if (paymentMethod=='Card' && cardId) {
          const response= await makePayment(data.data?.order?._id);
          if (!response.status) {
            setIsPlacingOrder(false);
            // toast.error(response.message);
            const result = await Swal.fire({
                title: 'Payment Failed!',
                text: response.message,
                icon: 'warning',
                // showCancelButton: true,
                confirmButtonColor: '#9E9B9B',
                confirmButtonText: 'OK',
                // cancelButtonColor: '#9E9B9B',
                // cancelButtonText: 'OK',
            });
            setIsPlacingOrder(false);
            return false;
          }
          transaction_id = response.data?.payment?.id;
        }
        
        setOrderId(data.data.order._id);
        setShowPopup(true);
        setIsPlacingOrder(false); // Hide placing order loader
        localStorage.removeItem('promo_code');
        localStorage.removeItem('apply_loyalty');
        localStorage.removeItem('cart_count');
        localStorage.removeItem('selected_card_id');
        localStorage.removeItem('save_for_future');
        
        // navigate(`/order/${data.data.order._id}`);
      } else {
        toast.error(data.message);
        setIsPlacingOrder(false); // Hide placing order loader on error
      }

    } catch (error) {
      console.error("API Error:", error);
      setIsPlacingOrder(false); // Hide placing order loader on error
    } finally {
      setIsLoader(false);
    }
  };


  const makePayment = async (orderId) => {
    try {
      const response = await ApiService.request({
        method: "POST",
        url: "/makePayment",
        data: { cardId, amount: cart.grand_total , order_id: orderId},
      });
      return response.data;
    } catch (error) {
      console.error("Payment Error:", error);
      return { status: false, message: "Payment failed" };
    }
  };


  const getCards = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: "GET",
        url: "/getCustomerCards",
      });
      const data = response.data;

      if (data.status) {
        setCards(data.data?.cards);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoader(false);
    }
  };

  const removeCard = async (deletedCardId, showConfirmation = true) => {
    try {
      // Only show confirmation if explicitly requested (for manual card deletion)
      if (showConfirmation && !window.confirm('Are you sure you want to delete this card?')) {
        return;
      }
      
      setIsLoader(true);
      const response = await ApiService.request({
        method: "POST",
        url: "/deleteCard",
        data: { cardId: deletedCardId }
      });
      const data = response.data;

      if (data.status) {
        if (showConfirmation) {
          toast.success("Card deleted successfully");
        }
        // Refresh cards list
        getCards();
        // Clear selected card if it was deleted
        if (cardId === deletedCardId) {
          setCardId('');
          localStorage.removeItem('selected_card_id');
          setPaymentMethod(activeTab === 'pickup' ? 'COP' : 'COD');
        }
      } else {
        if (showConfirmation) {
          toast.error(data.message);
        }
      }
      
    } catch (error) {
      console.error("API Error:", error);
      if (showConfirmation) {
        toast.error("Failed to delete card");
      }
    } finally {
      setIsLoader(false);
    }
  };

  const removePromo = () => {
    localStorage.removeItem('promo_code');
    // If there's an offer in URL, we can't remove it from checkout
    // User needs to go back to cart to remove it
    if (offer) {
      toast.info("Please go back to cart to remove this offer");
      return;
    }
    toast.success("Promo code removed successfully");
    getCart(); // Refresh cart to recalculate totals
  };

  return (
    <div className="main-heading container">
      
      <Header title={'Checkout'} back={'/cart'}/>
      

      <div className="d-flex justify-content-center align-items-center">
        {activeTab=='delivery' ?(
          <iframe
            src={'https://www.google.com/maps?q=' + address?.lat + ',' + address?.lng + '&hl=es;z=14&output=embed'}
            width="100%"
            height="200"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        ):(
          <iframe
            src={'https://www.google.com/maps?q=' + branch?.lat + ',' + branch?.lng + '&hl=es;z=14&output=embed'}
            width="100%"
            height="200"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        )}
        
      </div>
      {activeTab==='delivery' ? (
        <div className="">
          <div className="py-2 px-3 mx-2 border-bottom">
            <p className="text-capitalize fw-semibold my-2">Deliver To - {address?.type}</p>
            <div className="d-flex justify-content-between">
              <p>{address?.address}</p>
              <Link to='/address-list?goto=checkout' className="text-base fw-bold cart-discount-p">Change</Link>
            </div>
          </div>
          <Link to="/add-address"
            className="p-2 mx-3 border-bottom d-flex address-section justify-content-start align-items-center">
            <FaPlus />
            <p className="cart-discount-p mt-3 mx-2 fs-6">Add New Address</p>
          </Link>
        </div>
      ):(
        <div className="py-2 px-3 mx-2 border-bottom">
          <p className="text-capitalize fw-semibold my-2">Pickup From - {branch?.name}</p>
          <div className="d-flex justify-content-between">
            <p>{branch?.location}</p>
            <Link to='/?tab=pickup&change=true&goto=checkout' className="text-base fw-bold cart-discount-p">Change</Link>
          </div>
        </div>
      )}
      

     

      <PaymentSection
        activeTab={activeTab}
        paymentMethod={paymentMethod}
        setPaymentMethod={setPaymentMethod}
        cards={cards}
        cardId={cardId}
        setCardId={setCardId}
        removeCard={removeCard}
      />

        <div className="mt-4 border-bottom px-3">
          <h4>Order Summary</h4>
          {cart.cartItems && cart.cartItems.map((item, index) => (
            <div className="d-flex justify-content-between">
              <p>{item?.item?.title}</p>
              <p>AED {item?.total_price}</p>
            </div>
          ))}
         
        </div>

        <div className="d-flex justify-content-between border-bottom mt-3 px-3">
          <p className="text-secondary">Subtotal</p>
          <p className="text-secondary">AED {cart.subTotal}</p>
        </div>
        {cart.deliveryCharges > 0 &&
          <div className="d-flex justify-content-between border-bottom mt-3 px-3">
            <p className="text-secondary">Delivery Fee</p>
            <p className="text-secondary">AED {cart.deliveryCharges}</p>
          </div>
        }
        {cart.vat_amount > 0 &&
          <div className="d-flex justify-content-between border-bottom mt-3 px-3">
            <p className="text-secondary">VAT</p>
            <p className="text-secondary">AED {cart.vat_amount}</p>
          </div>
        }
        {cart.promo_discount > 0  &&
          <div className="d-flex justify-content-between border-bottom mt-3 px-3">
            <p className="text-secondary">
              {(offer) ? 'Offer' : 'Promo Code'} Discount: {promo_code || offer}
              <span 
                onClick={removePromo}
                className="bi bi-x fs-4 text-dark pt-2 cursor-pointer ms-2"
                style={{cursor: 'pointer'}}
                title="Remove promo code"
              ></span>
            </p>
            <p className="text-secondary">AED {cart.promo_discount}</p>
          </div>
        }
        {(String(apply_loyalty)=="true" && cart.loyalty_discount > 0)  &&
          <div className="d-flex justify-content-between border-bottom mt-3 px-3">
            <p className="text-secondary">Redeem Points </p>
            <p className="text-secondary">AED {cart.loyalty_discount}</p>
          </div>
        }
        <div className="text-secondary border-bottom mt-3 px-3">
          <p>
            by completing this order, I agree to all
            <span className="cart-discount-p"> terms & conditions.</span>
          </p>
        </div>
        <div className="d-flex justify-content-between align-items-center border-bottom my-4 px-3">
          <h5 className="fw-light">
            <span className="fw-bold">Total</span> (incl.VAT)
          </h5>
          <h5 className="fw-bold">AED {cart.grand_total}</h5>
        </div>
        <div className="cart-btn placeOrder d-flex justify-content-center align-items-center">
          <button disabled={isLoader || isPlacingOrder}
            className="place-order-btn btn rounded btn-lg ms-3 text-white"
            onClick={placeOrder}
          >  
            Place Order 
            {(isLoader || isPlacingOrder) &&  <span className="spinner-border spinner-border-sm "  role="status"></span>}
          </button>
        </div>
        {showPopup && <SuccessPopup orderId={orderId} onClose={() => setShowPopup(false)} />}
      
      {/* Order Placing Loader Overlay */}
      {isPlacingOrder && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" 
             style={{backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999}}>
          <div className="bg-white rounded-3 p-4 text-center shadow-lg">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <h5 className="text-dark mb-2">Placing Your Order</h5>
            <p className="text-muted mb-0">Please wait while we process your order...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Checkout;
